import { useContext } from 'react';
import Script from 'next/script';
import AppContext from '../../../context/AppContext';

export const VideoPlayerScripts = () => {
	const { playerVersion } = useContext(AppContext);
	const JwPlayerUrl = `https://videoplayer.smdg.ca/${playerVersion}`;

	const renderScripts = (
		<>
			<Script
				src="https://code.jquery.com/jquery-1.11.1.js"
				id="jquery-1.11.1"
				strategy="afterInteractive"
			/>
			<Script
				src={`${JwPlayerUrl}/ignore/js/omniture.js`}
				id="omniture_script-js"
				strategy="afterInteractive"
			/>
			<Script
				src={`${JwPlayerUrl}/ignore/js/omnitureHelper.js`}
				id="omniture_helper_script-js"
				strategy="afterInteractive"
			/>
			<Script
				src={`${JwPlayerUrl}/videoplayer.min.js`}
				id="ce_videoplayer_script-js"
				strategy="afterInteractive"
			/>
			<Script strategy="lazyOnload">
				{`
					var videoCssLink = document.createElement("link");
					videoCssLink.rel = "stylesheet";
					videoCssLink.href = "${JwPlayerUrl}/corus-theme.css";
					document.head.appendChild(videoCssLink);
				`}
			</Script>
		</>
	);

	return renderScripts;
};
